import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import clsx from 'clsx';
import Cell from './Cell';
import { wrapEvent } from './utils';

function Row(_ref) {
  var _ref$cellRenderer = _ref.cellRenderer,
      CellRenderer = _ref$cellRenderer === void 0 ? Cell : _ref$cellRenderer,
      className = _ref.className,
      eventBus = _ref.eventBus,
      rowIdx = _ref.rowIdx,
      isRowSelected = _ref.isRowSelected,
      lastFrozenColumnIndex = _ref.lastFrozenColumnIndex,
      copiedCellIdx = _ref.copiedCellIdx,
      draggedOverCellIdx = _ref.draggedOverCellIdx,
      row = _ref.row,
      viewportColumns = _ref.viewportColumns,
      selectedCellProps = _ref.selectedCellProps,
      onRowClick = _ref.onRowClick,
      rowClass = _ref.rowClass,
      setDraggedOverRowIdx = _ref.setDraggedOverRowIdx,
      onMouseEnter = _ref.onMouseEnter,
      top = _ref.top,
      ariaRowIndex = _ref['aria-rowindex'],
      ariaSelected = _ref['aria-selected'],
      props = _objectWithoutPropertiesLoose(_ref, ["cellRenderer", "className", "eventBus", "rowIdx", "isRowSelected", "lastFrozenColumnIndex", "copiedCellIdx", "draggedOverCellIdx", "row", "viewportColumns", "selectedCellProps", "onRowClick", "rowClass", "setDraggedOverRowIdx", "onMouseEnter", "top", "aria-rowindex", "aria-selected"]);

  function handleDragEnter() {
    setDraggedOverRowIdx === null || setDraggedOverRowIdx === void 0 ? void 0 : setDraggedOverRowIdx(rowIdx);
  }

  className = clsx('rdg-row', "rdg-row-" + (rowIdx % 2 === 0 ? 'even' : 'odd'), {
    'rdg-row-selected': isRowSelected
  }, rowClass === null || rowClass === void 0 ? void 0 : rowClass(row), className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    role: "row",
    "aria-rowindex": ariaRowIndex,
    "aria-selected": ariaSelected,
    className: className,
    onMouseEnter: wrapEvent(handleDragEnter, onMouseEnter),
    style: {
      top: top
    }
  }, props), viewportColumns.map(function (column) {
    return /*#__PURE__*/React.createElement(CellRenderer, {
      key: column.key,
      rowIdx: rowIdx,
      column: column,
      lastFrozenColumnIndex: lastFrozenColumnIndex,
      row: row,
      isCopied: copiedCellIdx === column.idx,
      isDraggedOver: draggedOverCellIdx === column.idx,
      isRowSelected: isRowSelected,
      eventBus: eventBus,
      selectedCellProps: (selectedCellProps === null || selectedCellProps === void 0 ? void 0 : selectedCellProps.idx) === column.idx ? selectedCellProps : undefined,
      onRowClick: onRowClick
    });
  }));
}

export default /*#__PURE__*/memo(Row);